import Modal from "./Modal";

interface MicPermissionModalProps {
  isOpen: boolean;
  onClose: () => void;
  productName: string;
  purpose: string;
}

export function MicPermissionModal({ isOpen, onClose, productName, purpose }: MicPermissionModalProps) {
  return (
    <Modal isOpen={isOpen} handleModal={onClose} contentClassName="!w-[520px]">
      <div className="flex flex-col gap-4">
        <h1 className="text-xl font-semibold">Microphone Access Required</h1>
        <p className="text-text-primary text-sm">
          {productName} requires microphone access to {purpose}.
          It looks like microphone access has been blocked.
        </p>
        <div className="bg-gray-50 rounded-xl flex flex-col gap-2">
          <p className="text-text-primary text-sm font-semibold">To re-enable microphone access:</p>
          <ol className="text-text-primary text-sm list-decimal list-inside flex flex-col gap-1.5">
            <li>Click the icon to the left of your browser's address bar</li>
            <li>Find <strong>Microphone</strong> and set it to <strong>Allow</strong></li>
            <li>Refresh the page and try again</li>
          </ol>
        </div>
        <div className="flex justify-end pr-2">
          <button
            onClick={onClose}
            className="px-6 py-2 rounded-full bg-primary text-white text-sm font-semibold hover:opacity-80 transition-opacity"
          >
            Got it
          </button>
        </div>
      </div>
    </Modal>
  );
}
